import React, { useEffect } from 'react';
import './directorio.css';
import { DirectorioItem } from '../../json/directorioittem';


const Directorio = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container directorio-container container-mh'>
            <div className='row'>
                <div>
                    <h3 className='title'>Directorio</h3>
                    <hr className='hr-gob' />
                </div>
            </div>

            <div className='row'>
                {
                    DirectorioItem.map((item, index) => (
                        <div key={index} className='col-md-3 col-sm-6 col-12'>
                            <div className='card'>
                                <div className='directorio_descripcion'>
                                    <br></br>
                                    <h5>{item.area}</h5>
                                    <h6>{item.lugar}</h6>
                                    <h6>{item.Telefono}</h6>
                                    <h6>{item.correo}</h6>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
           <br></br>
           <br>
           </br>

        </div>
    )
}

export default Directorio